<template>
  <span></span>
</template>

<script>
// @group Common
// Styled EndlessScroll component
export default {
  name: 'EndlessScroll',

  data: () => ({
    scrollNoMore: false
  }),

  props: {
    //got all data
    gotAll: {
     // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    // has min threshold
    minThreshold: {
      // `Number` 
      type: Number,
         // The default value is: `350`
      default: 350
    },
    //has load at
    loadAt: {
      // `Number` 
      type: Number,
         // The default value is: `.3`
      default: .3
    }
  },

  created () {
    window.addEventListener('scroll', this.scroll)
    this.scrollNoMore = this.gotAll
  },

  watch: {
    gotAll: {
      handler: function () {
        this.scrollNoMore = this.gotAll
      }
    }
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.scroll);
  },

  methods: {
    /**
   * @vuese
   * Used to detect sroll and emit a value fetch more
   */
    scroll () {
      window.onscroll = async () => {
        let threshold = (window.innerHeight * this.loadAt) < this.minThreshold ? this.minThreshold : (window.innerHeight * this.loadAt)
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - threshold

        if (bottomOfWindow && !this.scrollNoMore) {
          // Fire fetchmore when bottom of window is reached
          // @arg The argument is a string
          this.$emit('fetchMore')
        }
      };
    }
  }
}
</script>

<style>
</style>

